import moment from 'moment';
import SelectUserComponent from '../../../components/user/select-user.component';
import UserChannelMappingModel from '../../../models/user-channel-mapping/user-channel-mapping.model';
import ViewBase from '../../view-base.view';
import UserChannelMappingUploadDialog from './user-channel-mapping-upload.dialog';
import SelectCodeMasterCategoryComponent from '../../../components/code-master/select-code-master-category.component';
import { codeMasterType } from '../../../config/constants';
import { downloadResultFileByFileID } from '../../../models/file.model'

/**
 * User Channel Mapping View
 * 
 * This upload excel function will map all desire user with their respective channel
 * 
 * @author cmcnkhiep(Ryan)
 */
export default function UserChannelMappingView() {
  ViewBase.call(this);

  const DEFAULT_RESULT = {
    result: [],
    resultFileGUID: ''
  };
  const DEFAULT_FIlTERS = {
    userIds: [],
    userRole: ''
  };

  let isExcelUploadOpen = false;
  let uploadResult = structuredClone(DEFAULT_RESULT);
  let filters = structuredClone(DEFAULT_FIlTERS);

  function resetFilters() {
    filters = structuredClone(DEFAULT_FIlTERS);
  }

  const clearFilter = (e) => {
    e.preventDefault();
    resetFilters();
  };

  const requestParams = {
    get userList() {
      return filters.userIds.map(({ userID }) => userID);
    },
    get userRole() {
      return filters.userRole;
    },
  }

  const downloadManageChannelByUser = (e) => {
    e.preventDefault();

    this.showLoading();
    UserChannelMappingModel.exportManageChannelByUser(requestParams)
      .then(result => {
        downloadResultFileByFileID(result, `UserManageChannelDownload_${moment().format('YYYYMMDDhhmm')}.xlsx`)
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  const downloadUserChannelMappingResult = () => {
    downloadResultFileByFileID(uploadResult.resultFileGUID, `UserManageMapping_RESULT_${uploadResult.resultFileGUID}.xlsx`)
  }

  return {
    view: () => {
      return [
        /* SEARCH */
        m('.card.mb-3',
          m('.card-body',
            m('form.row.g-2.needs-validation[novalidate]', {
              onsubmit: downloadManageChannelByUser
            },
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=userIds]', this.getText('LT00000009', 'User')),
                m(SelectUserComponent, {
                  id: 'userIds',
                  selectedUserList: filters.userIds,
                  onSelect: (value) => {
                    filters.userIds = value;
                  }
                })
              ),
              m('.col-xl-3.col-lg-4.col-sm-6',
                m('label.form-label[for=userRole]', this.getText('LT00000060', 'User Role')),
                m(SelectCodeMasterCategoryComponent, {
                  id: 'userRole',
                  category: codeMasterType.userRole,
                  isMultiple: false,
                  keyOnly: true,
                  selectedItem: filters.userRole,
                  onSelect: (value) => {
                    filters.userRole = value;
                  }
                })
              ),

              // Search & clear buttons
              m('.col-xl-6.d-flex.align-items-end.gap-2',
                m('button.btn.btn-primary[type="submit"]', {
                }, this.getText("LT00000945", "Export Managed Channel")),
                m('button.btn.btn-white', {
                  onclick: clearFilter
                }, this.getText("LT00000031", "Clear")),
              ),
            )
          )
        ),

        /* TABLE */
        m('.card',
          m('.card-body',
            m('.row.g-2',
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary',
                  {
                    onclick: () => { isExcelUploadOpen = true; }
                  },
                  m('i.bi.bi-file-earmark-arrow-up-fill'),
                  this.getText('LT00000197', 'Excel Upload')
                ),
                m('button.btn.btn-primary',
                  {
                    disabled: !uploadResult.resultFileGUID,
                    onclick: downloadUserChannelMappingResult
                  },
                  m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText('LT00000018', 'Excel Download')
                )

              ),
              m('.col-12',
                m('.table-responsive',
                  m('table.table.table-hover.sticky-column-start',
                    m('thead',
                      m('tr.align-middle',
                        m('th', this.getText('LT00000049', 'User ID')),
                        m('th', this.getText('LT00000050', 'User Name')),
                        m('th', this.getText('LT00000946', 'Channel Code')),
                        m('th', this.getText('LT00000800', 'Channel Name')),
                        m('th', this.getText('LT00000579', 'Product')),
                        m('th', this.getText('LT00000875', 'Relation')),
                        m('th', this.getText('LT00000092', 'Action')),
                        m('th', this.getText('LT00000947', 'Result')),
                      )
                    ),
                    m('tbody',
                      (uploadResult.result.length === 0) &&
                      m('tr',
                        m('td[colspan=8]', this.getText("EM00000141", "No records found."))
                      ),
                      uploadResult.result.length > 0 &&
                      uploadResult.result.map((col) => [
                        m('tr.align-middle',
                          m('td', col.userId),
                          m('td', col.username),
                          m('td', col.channelCode),
                          m('td', col.channelName),
                          m('td', col.product),
                          m('td', col.relationName),
                          m('td', col.operation),
                          m('td', col.result),
                        )
                      ]),
                    )
                  )
                )
              ),
            )
          )
        ),
        m(UserChannelMappingUploadDialog,
          {
            isOpen: isExcelUploadOpen,
            onClose: () => { isExcelUploadOpen = false; },
            onResultChange: (res) => { uploadResult = res }
          }
        ),
        this.getBaseViews()
      ];
    }
  };
}
